import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../../client/stores";
import { resolveMenu, SitesMenu } from "../../chrome/Navigation.component";
import type {
    SitesTemplateInfernoMicrositeNavigation,
    SitesTemplateInfernoMicrositeSocial,
} from "../../generated/webapi.g";
import { MagicLink } from "../../ui";
import "./MicrositeMenu.style.scss";

interface MicrositeMenuProps {
    navigation?: SitesTemplateInfernoMicrositeNavigation | null;
    social?: SitesTemplateInfernoMicrositeSocial;
    store?: Store;
}

export const MicrositeMenu = inject("store")(({ navigation, store }: MicrositeMenuProps) => {
    if (!store || !navigation || !navigation.menu || !navigation.enable_nav_switch) {
        return null;
    }
    const menu: SitesMenu[] = navigation.enable_nav_switch
        ? navigation.menu.filter(Boolean).map(m => resolveMenu(m, store.env.MICROSITE_ROOT, store.microsite, {}))
        : [];
    if (menu.length) {
        return (
            <nav className="component-microsite-menu">
                <hr className="divider" />
                <ul className="menu-items">
                    {menu.map((menuItem, i) => (
                        <li key={i}>
                            <MagicLink to={menuItem.href || "#"} target={menuItem.target || "_top"}>
                                {menuItem.label}
                            </MagicLink>
                        </li>
                    ))}
                </ul>
            </nav>
        );
    }
    return null;
});

export default MicrositeMenu;
